import React, { Component } from 'react'
import classes from './DailyFeedbackReport.module.css';
import Button from '../UI/Button/Button';
import { IsListEmpty, IsObjectEmpty, IsStringEmpty } from '../../utilities/CommonMethods';
import ShowLoader from '../../hoc/ShowLoader/ShowLoader';
import ProgressBar from '../UI/ProgressBar/ProgressBar';
import SessionEngagementProgressBar from '../UI/SessionEngagementProgressBar/SessionEngagementProgressBar';
import { Chart } from 'react-google-charts';

class DailyFeedbackReportCardNew extends Component {

    state = {
        boringValue: 0,
        engagingValue: 0,
        totalResponses: 0
    }


    setComponentData = () => {
        let boring = 0, engaging = 0,
            totalResponses = !IsObjectEmpty(this.props.currentTopicDetails) && this.props.currentTopicDetails.responsesReceived > 0 ? this.props.currentTopicDetails.responsesReceived : 0;

        if (totalResponses > 0 && !IsListEmpty(this.props.pieChartData)) {
            let completelyUnderstood = this.props.pieChartData[1][1],
                partiallyUnderstood = this.props.pieChartData[2][1],
                didNotUnderstood = this.props.pieChartData[3][1];
            engaging = Math.round((completelyUnderstood) / totalResponses * 100);
            boring = Math.round((didNotUnderstood + partiallyUnderstood) / totalResponses * 100);
        }

        this.setState({ boringValue: boring, engagingValue: engaging, totalResponses })
    }

    componentDidMount() {
        this.setComponentData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentTopicDetails !== this.props.currentTopicDetails) {
            this.setComponentData();
        }
    }

    render() {
        const subtopics = this.props.feedbackResponses.subtopics;
        const pieChartData = [
            ['Category', 'Value'],
            ...subtopics.map((subtopic) => [subtopic.title, subtopic.progressValue]),
        ];
        return (
            <>
                {
                    this.props.showCardLoader
                        ?
                        <div className={classes.ReportCard}>
                            <div className={classes.LoaderContainer}>
                                <ShowLoader isLoading={true} transparentBg={true} />
                            </div>
                        </div>
                        :
                        <>
                            <div className={classes.ReportCard}>
                                <div>
                                    {(this.props.isProgramManager) && this.props.forOverallReport !== true && this.props.currentTopicDetails.responsesReceived > 0
                                        ?
                                        <div className={classes.ButtonContainer}>
                                            <Button
                                                label="VIEW ALL RESPONSES"
                                                styleclass="TextOnlyButtonBlue"
                                                clicked={this.props.onViewAllResponsesClicked} />
                                        </div>
                                        : null
                                    }

                                    <h4 className={classes.TopicName}>{this.props.currentTopicDetails.topicName}</h4>
                                    <p className={classes.Date}>{this.props.currentTopicDetails.date}</p>
                                    {
                                        (this.props.isProgramManager) && this.props.forOverallReport !== true && this.props.currentTopicDetails.responsesReceived > 0
                                            ? <p className={classes.ResponsesText} title="Click to view individual student responses"
                                                onClick={this.props.onViewAllResponsesClicked}>
                                                {this.props.currentTopicDetails.responsesReceived} RESPONSES</p>
                                            : <p className={classes.ResponsesTextInactive} >
                                                {this.props.currentTopicDetails.responsesReceived} RESPONSES</p>
                                    }
                                </div>
                                {
                                    this.state.totalResponses === 0
                                        ? <p className={classes.Fbtag}>Feedback responses not available!</p>
                                        : <>
                                            {/* <div className={classes.ContainerDiv}>
                                                <div className={classes.ProgressBarsContainer}>

                                                    <div className={classes.CircularProgressBarDiv}>
                                                        <div className={classes.Stars}
                                                            style={{
                                                                "--rating": (this.props.overallSessionRating.fraction[1] === 10
                                                                    ? this.props.overallSessionRating.fraction[0] / 2
                                                                    : this.props.overallSessionRating.fraction[0])
                                                            }}>
                                                        </div>
                                                        <p className={classes.DescriptionText}>SESSION RATING</p>
                                                        <div className={classes.RatingText}>
                                                            {
                                                                (this.props.overallSessionRating.fraction[1] === 10
                                                                    ? this.props.overallSessionRating.fraction[0] / 2
                                                                    : this.props.overallSessionRating.fraction[0])
                                                            }
                                                        </div>
                                                        <p className={classes.GreyText}>OUT OF {5}</p>
                                                        <p className={classes.DescriptionText} style={{ marginTop: "2em" }}>{this.props.feedbackType === "daily" ? "TOPICS UNDERSTOOD" : "SESSION ENGAGEMENT"}</p>
                                                    </div>
                                                </div>
                                            </div> */}
                                            <div className={classes.ReportRating}>
                                                <p className={classes.DescriptionText}>SESSION RATING</p>
                                                <div className={classes.Stars}
                                                    style={{
                                                        "--rating": (this.props.overallSessionRating.fraction[1] === 10
                                                            ? this.props.overallSessionRating.fraction[0] / 2
                                                            : this.props.overallSessionRating.fraction[0])
                                                    }}>
                                                </div>
                                                <div className={classes.RatingText}>
                                                    {
                                                        (this.props.overallSessionRating.fraction[1] === 10
                                                            ? this.props.overallSessionRating.fraction[0] / 2
                                                            : this.props.overallSessionRating.fraction[0])
                                                    }
                                                    <p className={classes.GreyText}>OUT OF {5}</p>
                                                </div>

                                            </div>
                                            {
                                                this.props.showNoteText === true && this.props.isProgramManager !== true
                                                    ? <p className={classes.NoteText}>
                                                        Note: This session was conducted by another instructor.
                                                    </p>
                                                    : null
                                            }
                                        </>
                                }
                            </div>
                            <div className={classes.NewCharts}>
                                {
                                    this.state.engagingValue === 0 && this.state.boringValue === 0
                                        ? null
                                        :
                                        <div className={classes.SectionCard1}>
                                            <Chart
                                                width={'100%'}
                                                height={'400px'}
                                                chartType="PieChart"
                                                loader={<div>Loading Chart</div>}
                                                data={[
                                                    ['Category', 'Percentage'],
                                                    ['ENGAGING', this.state.engagingValue],
                                                    ['BORING', this.state.boringValue],
                                                ]}
                                                options={{
                                                    title: '',
                                                    pieHole: 0.3,
                                                    colors: ['#04B513', '#FF6D01'],
                                                }}
                                            />
                                        </div>
                                }
                                {
                                    IsObjectEmpty(this.props.feedbackResponses.subtopics)
                                        ? null
                                        :
                                        <div className={classes.SectionCard2}>
                                            {/* <p className={classes.DescriptionText}>{this.props.feedbackType === 'daily' ? "SUBTOPICS UNDERSTOOD" : "AREAS OF IMPROVEMENT"}</p> */}
                                            <Chart
                                                width={'100%'}
                                                height={'400px'}
                                                chartType="PieChart"
                                                loader={<div>Loading Chart</div>}
                                                data={pieChartData}
                                                options={{
                                                    title: '',
                                                    pieHole: 0.3,
                                                    colors: ['#FBBC04', '#4A86E8', '#46BDC6', '#FF6D01', '#04B513'],
                                                }}
                                            />
                                        </div>
                                }

                            </div>

                        </>
                }
            </>
        )
    }
}


export default DailyFeedbackReportCardNew;